import React from "react";
import { Link } from "react-router-dom";

export default function Guide() {
  const steps = [
    { t: "1. Register with your mobile", d: "Use your 10-digit mobile number and set a strong password (min 8 chars, letters + numbers)." },
    { t: "2. Set your secret number & image", d: "Choose one number (0–999) and one image. You'll need both to recover a forgotten password." },
    { t: "3. Complete your school profile", d: "Add School name, UDISE code, block, district, Headmaster name and enrolled students per class." },
    { t: "4. Make a daily entry", d: "Pick the date, enter present students per class, and tap Calculate. Save the entry." },
    { t: "5. Generate reports", d: "Open Reports to view Daily, Weekly, Monthly (MDCF), Annual and UC reports. Download PDF/Excel or share on WhatsApp." },
  ];
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <h1 className="text-3xl md:text-4xl font-heading font-extrabold mb-6">User Guide</h1>
      <div className="space-y-4">
        {steps.map((s, i) => (
          <div key={i} className="card-thali" data-testid={`guide-step-${i}`}>
            <h3 className="font-heading font-bold text-lg text-thali-green">{s.t}</h3>
            <p className="text-sm text-thali-ink/70 mt-1">{s.d}</p>
          </div>
        ))}
      </div>
      <Link to="/register" className="btn-3d-saffron mt-8">Get Started</Link>
    </div>
  );
}
